<template>
  <div>
    <v-row justify="center">
        <v-dialog v-model="$store.state.showDialogGuia.historico" max-width="600px">
          <v-overlay :value="$store.state.isloading">
    <v-progress-circular
      indeterminate
      size="64"
    ></v-progress-circular>
  </v-overlay>
          <v-card>
            <v-card-title>
              <span class="headline">Informações Pessoais</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <span>Nome completo: <v-chip color="primary">{{($store.state.objAluno === undefined)?'':$store.state.objAluno.nome}}</v-chip> </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <span>Número de matricula:    <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.idMAtricula}}</strong>  </span>
                  </v-col>
                   <v-col cols="12" sm="6" md="6">
                    <span>Nº Bilhete: <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.bi}}</strong> </span>
                  </v-col>
                   <v-col cols="12" sm="6" md="6">
                    <span>Curso :  <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.curso}}</strong> </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <span>Classe : <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.classe}}</strong> </span>
                  </v-col>

                  <v-col cols="12" sm="6" md="12">
                       <v-card-title>
                          <span class="headline">Outras Informações</span>
                      </v-card-title>
                  </v-col>

                  <v-col cols="12" sm="4">
                     <v-select
                      v-model="modelo"
                      item-value="id"
                      item-text="descricao"
                      :items="modelosImpressao"
                      label="Modelo de Impressão"
                      return-object
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="sair()">Cancelar</v-btn>
               <v-btn color="green darken-1" text @click="carregarRelatorio()">Vizualizar</v-btn>
             </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
  </div>
  </template>
<script>
import axios from '../../../plugins/axios'
import impressao from '../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    soma: 0,
    contador: 0,
    configuracoes: ls.get('configuracoesReport'),
    historico_relatorio: '',
    componente1: [],
    componente2: [],
    componente3: [],
    componente4: [],
    historicoNotas: [],
    empresa: {
      decreto: 'Decreto nº 207/11 de 2 de Agosto de 2011',
      distrito: 'Distrito Urbano 11 de Novembro',
      nif: '5417113387',
      provincia: 'Luanda',
      municipio: 'Cazenga',
      dataemissao: '27/08/1999',
      pais: 'Angola',
      email: 'colegioilhadaverdade2021@gmail.com',
      telefone1: '(+22) 923716242',
      telefone2: '222788370'
    },
    estudante_dados: [],
    relatorio: ls.get('relatorio-estudante'),
    html: ``,
    titulo: '',
    modelosImpressao: [{ id: 1, descricao: 'IMS' }, { id: 2, descricao: 'Local' }],
    modelo: { id: 1, descricao: 'IMS' }
  }),
  computed: {
    isModeloIMS () {
      return this.modelo.id === 2 ? ls.get('i_id') : 1
    }
  },
  watch: {
  },
  created  () {
    this.$store.state.isloading = false
    this.estudante_dados = this.$store.state.listEstudantfromPauta // this.$store.state.objAluno
    this.carregarDisciplinaBackup()
  },
  methods: {

    async carregarRelatorio () {
      this.$store.state.isloading = true
      try {
        this.historico_relatorio = await axios
          .get('/obterRelatorioByDescricao/ha')
          .then(res => res.data)
        this.historico_relatorio = this.historico_relatorio.filter(r => r.idinstituicao === this.isModeloIMS)
        if (!this.historico_relatorio.length) {
          Swal.fire({ icon: 'info', title: '', text: 'Histórico Académico, não configurada!' })
        } else {
          this.carregarNota()
        }
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o relatório'
        })
      } finally {
        this.$store.state.isloading = false
      }
    },
    async carregarDisciplinaBackup () {
      try {
        this.disciplinasbackup = await axios.get('/obterDisciplinaBackup').then(res => res.data)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o histórico de notas'
        })
      }
    },
    async carregarNota () {
      try {
        let finalista = this.estudante_dados[0]
        let notas = await axios
          .post('/obter-historicoNotas', finalista)
          .then(res => res.data)
        this.verificardisciplinasBackup(notas)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o histórico de notas'
        })
      }
    },
    verificardisciplinasBackup (notas) {
      let auxNotas = notas.filter(n => !n.disciplina)
      for (let i = 0; i < auxNotas.length; i++) {
        const item = auxNotas[i]
        const index = notas.indexOf(item)
        let auxElementDisciplinaBackup = this.disciplinasbackup.filter(d => d.iddisciplina == item.iddisciplina)
        if (auxElementDisciplinaBackup.length) {
          notas[index].disciplina = auxElementDisciplinaBackup[0].descricao
          notas[index].idCurso = auxElementDisciplinaBackup[0].idCurso
          notas[index].controliddisciplina = auxElementDisciplinaBackup[0].controliddisciplina
          notas[index].componente = auxElementDisciplinaBackup[0].componente
        }
      }
      this.carregarHistorico(notas)
    },
    async carregarHistorico (notas) {
      let finalista = this.estudante_dados[0]
      try {
        this.historicoNotas = await axios
          .post('/obter-disciplinas-historico-modelo', finalista)
          .then(res => res.data)
        this.estudantes = finalista
        // @ts-ignore
        this.componente1 = this.historicoNotas.filter(p => p.componente === 1)

        // @ts-ignore
        this.componente2 = this.historicoNotas.filter(p => p.componente === 2)

        // @ts-ignore
        this.componente3 = this.historicoNotas.filter(p => p.componente === 3 && !(p.descricao.toUpperCase()).includes('CLASSIFICAÇÃO'))

        // @ts-ignore
        this.componente4 = this.historicoNotas.filter(p => p.componente === 3 && (p.descricao.toUpperCase()).includes('CLASSIFICAÇÃO'))
        if (this.historico_relatorio.length && this.historicoNotas.length) {
          this.soma = 0
          this.contador = 0
          this.iterarComponente1(notas)
        } else {
          this.$store.dispatch('textMessage', { 'msg': 'Dados não carregados', 'classMessage': 'msgWarning', 'timeout': 3000 })
        }
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o modelo de disciplinas'
        })
      }
    },
    formatarDataParaDescricao (data) {
      const d = new Date(data)
      const meses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]

      const dia = d.getDate()
      const mes = meses[d.getMonth()]
      const ano = d.getFullYear()

      return `${dia} de ${mes} de ${ano}`
    },

    async comporHistoricoAcademico (itercomponente1, itercomponente2, itercomponente3, itercomponente4, extra, pc, mediafinal) {
      try {
        const dataAtual = new Date()
        const data = this.formatarDataParaDescricao(dataAtual)
        // @ts-ignore
        let documento = this.historico_relatorio[0].documento

        documento = documento.replace(/{{totallinhas}}/g, (10 + this.historicoNotas.length))
        documento = documento.replace(/{{insignia}}/g, ls.get('insignia'))
        documento = documento.replace(/{{logotipoInstituicao}}/g, ls.get('logotipo'))
        documento = documento.replace(/{{instituicao}}/g, ls.get('nomeInstituicao').toUpperCase())
        documento = documento.replace(/{{decreto}}/g, this.empresa.decreto)
        documento = documento.replace(/{{nif}}/g, this.empresa.nif)
        documento = documento.replace(/{{distrito}}/g, this.empresa.distrito)
        documento = documento.replace(/{{municipioInstituicao}}/g, this.empresa.municipio)
        documento = documento.replace(/{{provinciaInstituicao}}/g, this.empresa.provincia)
        documento = documento.replace(/{{tel1}}/g, this.empresa.telefone1)
        documento = documento.replace(/{{tel2}}/g, this.empresa.telefone2)
        documento = documento.replace(/{{emailInstituicao}}/g, this.empresa.email)
        documento = documento.replace(/{{matricula}}/g, this.estudantes.idMatricula)

        // @ts-ignore
        documento = documento.replace(/{{nomeAluno}}/g, this.estudantes.nome)
        // @ts-ignore
        documento = documento.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
        // @ts-ignore
        documento = documento.replace(/{{bi}}/g, this.estudantes.bi)
        // @ts-ignore
        documento = documento.replace(/{{municipio}}/g, this.estudantes.municipio)
        // @ts-ignore
        documento = documento.replace(/{{provincia}}/g, this.estudantes.provincia)
        documento = documento.replace(/{{pai}}/g, this.estudantes.nomedopai)
        documento = documento.replace(/{{mae}}/g, this.estudantes.nomedamae)
        documento = documento.replace(/{{dataemissao}}/g, this.estudantes.dataemissaobi)
        documento = documento.replace(/{{datanascimento}}/g, (this.estudantes.datanascimento !== null ? this.estudantes.datanascimento : ''))
        documento = documento.replace(/{{pais}}/g, 'Angola')
        // @ts-ignore
        documento = documento.replace(/{{curso}}/g, (this.estudantes.descricao.toUpperCase()))
        documento = documento.replace(/{{dataActual}}/g, data)
        let config = ls.get('configuracoesReport')
        let dg = config.filter(c => c.chave === 'director_geral')
        // @ts-ignore
        let insc1 = this.estudante_dados.filter(e => e.idAno_Academico === 1)
        let insc2 = this.estudante_dados.filter(e => e.idAno_Academico === 2)
        let insc3 = this.estudante_dados.filter(e => e.idAno_Academico === 3)
        let insc4 = this.estudante_dados.filter(e => e.idAno_Academico === 4)
        documento = documento.replace(/{{anolectivo1}}/g, (insc1.length ? insc1[0].anoLectivo : ''))
        documento = documento.replace(/{{anolectivo2}}/g, (insc2.length ? insc2[0].anoLectivo : ''))
        documento = documento.replace(/{{anolectivo3}}/g, (insc3.length ? insc3[0].anoLectivo : ''))
        documento = documento.replace(/{{anolectivo4}}/g, (insc4.length ? insc4[0].anoLectivo : ''))
        documento = documento.replace(/{{turma1}}/g, (insc1.length ? insc1[0].turma : ''))
        documento = documento.replace(/{{turma2}}/g, (insc2.length ? insc2[0].turma : ''))
        documento = documento.replace(/{{turma3}}/g, (insc3.length ? insc3[0].turma : ''))
        documento = documento.replace(/{{turma4}}/g, (insc4.length ? insc4[0].turma : ''))

        documento = documento.replace(/{{anolectivo}}/g, this.estudantes.anoLectivo)
        documento = documento.replace(/{{totalcargahoraria}}/g, '')
        documento = documento.replace(/{{director}}/g, (dg.length ? dg[0].valor : ''))
        documento = documento.replace(/{{director_profissao}}/g, '*' + (dg.length ? dg[1].valor + '*' : ''))
        documento = documento.replace(/{{subdirector}}/g, ls.get('subdirector'))
        documento = documento.replace(/{{pc}}/g, pc)
        documento = documento.replace(/{{mediacurso}}/g, mediafinal)
        /** Componente 1 */
        documento = documento.replace(/{{componente1}}/g, itercomponente1)
        /** Componente 2 */
        documento = documento.replace(/{{componente2}}/g, itercomponente2)
        /** Componente 3 */
        documento = documento.replace(/{{componente3}}/g, itercomponente3)
        /** Componente 4 */
        documento = documento.replace(/{{componente4}}/g, itercomponente4)

        documento = documento.replace(/{{componente4_}}/g, extra)

        this.html = documento
        let options = { 'format': 'A4',
          'border': {
            'right': '10mm',
            'left': '10mm'
          },
          'header': {
            'height': '5mm'
          },
          'footer': {
            'height': '5mm'
          } }
        impressao.htmlToPDF(this.html, options, ls.get('urlReport'), ls.get('idPessoa'))
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor o documento'
        })
      } finally {
        this.sair()
      }
    },

    isNull (valor) {
      return (valor !== null ? valor : '')
    },
    /** Componente 1 */
    iterarComponente1 (notas) {
      try {
        let componenteHtml = ``
        for (let index = 0; index < this.componente1.length; index++) {
          const element = this.componente1[index]
          const linha = notas.filter(n => n.disciplina === element.descricao)
          this.soma += (element.mfd === null) ? 0 : parseInt(element.mfd)
          this.contador++
          if (index === 0) {
          // @ts-ignore
            let documentoIteracao1 = this.historico_relatorio[0].documentoiteracao1
            documentoIteracao1 = documentoIteracao1.replace(/{{componenteLengthDisciplinas}}/g, this.componente1.length)
            documentoIteracao1 = documentoIteracao1.replace(/{{nomeComponente}}/g, 'SOCIOCULTURAL')
            documentoIteracao1 = documentoIteracao1.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, this.isNull(element.mfd))
            documentoIteracao1 = documentoIteracao1.replace(/{{cargahoraria}}/g, '')
            componenteHtml = documentoIteracao1
          } else {
          // @ts-ignore
            let documentoIteracao2 = this.historico_relatorio[0].documentoiteracao2
            documentoIteracao2 = documentoIteracao2.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, this.isNull(element.mfd))
            documentoIteracao2 = documentoIteracao2.replace(/{{cargahoraria}}/g, '')
            componenteHtml += documentoIteracao2
          }
        }
        this.iterarComponente2(componenteHtml, notas)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor a componente 1'
        })
      }
    },
    /** Componente 2 */
    iterarComponente2 (c1, notas) {
      try {
        let componenteHtml = ``
        for (let index = 0; index < this.componente2.length; index++) {
          const element = this.componente2[index]
          const linha = notas.filter(n => n.disciplina === element.descricao)
          this.soma += (element.mfd === null) ? 0 : parseInt(element.mfd)
          this.contador++
          if (index === 0) {
          // @ts-ignore
            let documentoIteracao1 = this.historico_relatorio[0].documentoiteracao1
            documentoIteracao1 = documentoIteracao1.replace(/{{componenteLengthDisciplinas}}/g, this.componente2.length)
            documentoIteracao1 = documentoIteracao1.replace(/{{nomeComponente}}/g, 'CIENTÍFICA')
            documentoIteracao1 = documentoIteracao1.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, this.isNull(element.mfd))
            documentoIteracao1 = documentoIteracao1.replace(/{{cargahoraria}}/g, '')
            componenteHtml = documentoIteracao1
          } else {
          // @ts-ignore
            let documentoIteracao2 = this.historico_relatorio[0].documentoiteracao2
            documentoIteracao2 = documentoIteracao2.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, this.isNull(element.mfd))
            documentoIteracao2 = documentoIteracao2.replace(/{{cargahoraria}}/g, '')
            componenteHtml += documentoIteracao2
          }
        }
        this.iterarComponente3(c1, componenteHtml, notas)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor a componente 2'
        })
      }
    },
    /** Componente 3 */
    iterarComponente3 (c1, c2, notas) {
      try {
        let componenteHtml = ``
        for (let index = 0; index < this.componente3.length; index++) {
          const element = this.componente3[index]
          const linha = notas.filter(n => n.disciplina === element.descricao)
          this.soma += (element.mfd === null) ? 0 : parseInt(element.mfd)
          this.contador++
          if (index === 0) {
          // @ts-ignore
            let documentoIteracao1 = this.historico_relatorio[0].documentoiteracao1
            documentoIteracao1 = documentoIteracao1.replace(/{{componenteLengthDisciplinas}}/g, this.componente3.length)
            documentoIteracao1 = documentoIteracao1.replace(/{{nomeComponente}}/g, 'TÉCNICA, TECNOLÓGICA E PRÁTICA')
            documentoIteracao1 = documentoIteracao1.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, this.isNull(element.mfd))
            documentoIteracao1 = documentoIteracao1.replace(/{{cargahoraria}}/g, '')
            componenteHtml = documentoIteracao1
          } else {
          // @ts-ignore
            let documentoIteracao2 = this.historico_relatorio[0].documentoiteracao2
            documentoIteracao2 = documentoIteracao2.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, this.isNull(element.mfd))
            documentoIteracao2 = documentoIteracao2.replace(/{{cargahoraria}}/g, '')
            componenteHtml += documentoIteracao2
          }
        }
        this.iterarComponente4(c1, c2, componenteHtml, notas)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor a componente 3'
        })
      }
    },
    /** Componente 4 */
    iterarComponente4 (c1, c2, c3, notas) {
      try {
        let componenteHtml = ``
        let componenteHtml_ = ``
        let lastSumDisciplinas = 0
        for (let index = 0; index < this.componente4.length; index++) {
          const element = this.componente4[index]
          const linha = notas.filter(n => n.disciplina === element.descricao)
          lastSumDisciplinas += (element.mfd) ? parseInt(element.mfd) : 0
          if (index === 0) {
          // @ts-ignore
            let documentoIteracao1 = this.historico_relatorio[0].documentoiteracao1
            let documentoIteracao1_ = this.historico_relatorio[0].documentoiteracao3
            documentoIteracao1 = documentoIteracao1.replace(/{{componenteLengthDisciplinas}}/g, this.componente4.length)
            documentoIteracao1 = documentoIteracao1.replace(/{{nomeComponente}}/g, 'COMPLEMENTAR')
            documentoIteracao1 = documentoIteracao1.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, this.isNull(element.mfd))
            documentoIteracao1 = documentoIteracao1.replace(/{{cargahoraria}}/g, '')

            if (documentoIteracao1_) {
              documentoIteracao1_ = documentoIteracao1_.replace(/{{disciplina}}/g, element.descricao)
              documentoIteracao1_ = documentoIteracao1_.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
              documentoIteracao1_ = documentoIteracao1_.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
              documentoIteracao1_ = documentoIteracao1_.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
              documentoIteracao1_ = documentoIteracao1_.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
              documentoIteracao1_ = documentoIteracao1_.replace(/{{media}}/g, this.isNull(element.mfd))
            }

            componenteHtml = documentoIteracao1
            componenteHtml_ = documentoIteracao1_
          } else {
            // @ts-ignore
            let documentoIteracao2 = this.historico_relatorio[0].documentoiteracao2
            let documentoIteracao1_ = this.historico_relatorio[0].documentoiteracao3
            documentoIteracao2 = documentoIteracao2.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, this.isNull(element.mfd))
            documentoIteracao2 = documentoIteracao2.replace(/{{cargahoraria}}/g, '')

            if (documentoIteracao1_) {
              documentoIteracao1_ = documentoIteracao1_.replace(/{{disciplina}}/g, element.descricao)
              documentoIteracao1_ = documentoIteracao1_.replace(/{{isClasse1}}/g, (linha.length ? linha[0].classe1 : ''))
              documentoIteracao1_ = documentoIteracao1_.replace(/{{isClasse2}}/g, (linha.length ? linha[0].classe2 : ''))
              documentoIteracao1_ = documentoIteracao1_.replace(/{{isClasse3}}/g, (linha.length ? linha[0].classe3 : ''))
              documentoIteracao1_ = documentoIteracao1_.replace(/{{isClasse4}}/g, (linha.length ? linha[0].classe4 : ''))
              documentoIteracao1_ = documentoIteracao1_.replace(/{{media}}/g, this.isNull(element.mfd))
            }

            componenteHtml += documentoIteracao2
            componenteHtml_ += documentoIteracao1_
          }
        }
        let pc = Math.round(this.soma / this.contador)
        let mediafinal = Math.round((4 * pc + lastSumDisciplinas) / 6)
        this.comporHistoricoAcademico(c1, c2, c3, componenteHtml, componenteHtml_, pc, mediafinal)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor a componente 4'
        })
      }
    },

    sair () {
      this.$store.state.isloading = false
      this.$store.state.showDialogGuia.historico = false
    },
    dataActual () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
    },
    dataExtensao (dateString) {
    // dateString = dateString.split('/')
      dateString = dateString.split('-')
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return dateString[0] + ' de ' + month[parseInt(dateString[1]) - 1] + ' de ' + dateString[2]
    },
    dataExtensaobi (dateString) {
    // dateString = dateString.split('/')
      dateString = dateString.split('-')
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return dateString[0] + ' de ' + month[parseInt(dateString[1]) - 1] + ' de ' + dateString[2]
    }
  }
}

</script>
